import $ from "jquery";

function HtmlToText(html) {
  const doc = document.implementation.createHTMLDocument("");

  doc.body.innerHTML = html;

  return $(doc.body).clone().find("style").remove().end().text();
}

export { HtmlToText };
